module.exports = __webpack_public_path__ + "img/logo-4.97e9b143.png";